export default "__VITE_ASSET__cd000bcd__"